// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
  width: 100%;
  min-height: 100vh;
  padding: 12px 12px 42px 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.tabs .tabs-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 40px 0;
}
.tabs .tabs-logo img {
  height: 2rem;
}
.tabs .tabs-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  flex-grow: 1;
}
.tabs .tabs-buttons .tabs-buttons-button {
  display: flex;
  align-items: center;
  background-color: #27272E;
  border-radius: 8px;
  padding: 8px;
  gap: 12px;
}
.tabs .tabs-buttons .tabs-buttons-button span p {
  padding: 0;
  margin: 0;
}
.tabs .tabs-logout {
  width: 100%;
  text-align: center;
}
.tabs .tabs-logout p {
  text-decoration: underline;
}
@media (min-width: 520px) and (max-width: 1200px) {
  .tabs .tabs-buttons-button {
    justify-content: center;
  }
  .tabs .tabs-buttons-button .tabs-buttons-button-nombre {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/tabs/tabs.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AACJ;AACI;EACE,YAAA;AACN;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;AADN;AAGM;EACE,UAAA;EACA,SAAA;AADR;AAME;EACE,WAAA;EACA,kBAAA;AAJJ;AAMI;EACE,0BAAA;AAJN;AAQE;EAEE;IACE,uBAAA;EAPJ;EASE;IACE,aAAA;EAPJ;AACF","sourcesContent":[".tabs {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  padding: 12px 12px 42px 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n\r\n  .tabs-logo {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    padding: 40px 0;\r\n\r\n    img {\r\n      height: 2rem;\r\n    }\r\n  }\r\n\r\n  .tabs-buttons {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n    width: 100%;\r\n    flex-grow: 1;\r\n\r\n    .tabs-buttons-button {\r\n      display: flex;\r\n      align-items: center;\r\n      background-color: #27272E;\r\n      border-radius: 8px;\r\n      padding: 8px;\r\n      gap: 12px;\r\n\r\n      span p {\r\n        padding: 0;\r\n        margin: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .tabs-logout {\r\n    width: 100%;\r\n    text-align: center;\r\n\r\n    p{\r\n      text-decoration: underline;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 520px) and (max-width: 1200px) {\r\n\r\n    .tabs-buttons-button {\r\n      justify-content: center;\r\n    }\r\n    .tabs-buttons-button .tabs-buttons-button-nombre {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
